module.exports = __webpack_public_path__ + "img/thumbnail_Koala_j_normal.40cf324a.png";